import React from "react";
import {useSelector} from "react-redux";
import Cookies from 'universal-cookie';
import {VideoControls} from "./Videocontrols";

interface IProps {
    setShowIntro: (intro: boolean) => void
}

export const IntroVideo = (props: IProps) => {
    const {setShowIntro} = props;
    const cookies = new Cookies();
    const [playing, setPlaying] = React.useState<boolean>(false);
    const explainerVideo = React.useRef<any>(null);
    const [duration, setDuration] = React.useState<any>(0);
    const [muted, setMuted] = React.useState<boolean>(false);
    const [dontshow, setDontshow] = React.useState<boolean>(false);
    const [currentVideoTime, setCurrentVideoTime] = React.useState<number>(0);

    const introUrl = useSelector((state: any) => state.questionReducer.introUrl);

    React.useEffect(() => {
        if (explainerVideo.current) {
            explainerVideo.current.removeEventListener('timeupdate', timeUpdateAction);
            explainerVideo.current.addEventListener('timeupdate', timeUpdateAction);
            explainerVideo.current.removeEventListener('ended', endedAction);
            explainerVideo.current.addEventListener('ended', endedAction);
        }
    }, [explainerVideo.current])

    function timeUpdateAction() {
        if (explainerVideo.current) {
            let currentTime = explainerVideo.current.currentTime
            setCurrentVideoTime(currentTime);
        }
    }

    function handlePlay() {
        setPlaying(true);
        explainerVideo.current.play()
    }

    const endedAction = () => {
        if (dontshow === true) {
            cookies.set('tc-genything-intro-donotshow', true);
        }
        setShowIntro(false);
    }
    const handleLoadedMetadata = () => {
        const video: any = explainerVideo.current;
        if (!video) return;

        setDuration(video.duration);
    };
    const handleCheckboxChange = (event: any) => {
        setDontshow(event.target.checked);
    }
    const playVideo = () => {
        const video: any = explainerVideo.current;
        if (!video) return;

        if (playing) {
            video.pause();
        } else {
            video.play();
        }
        setPlaying(!playing)
    }
    const onEndVideo = () => {
        setShowIntro(false);
    }

    return (
        <div className="di-question-main-container">
            <div className="disable-block d-none"/>
            <div>
                <div className='di-question-container'>
                    <div className="di-video-main-wrapper">
                        <div className="di-video-gradient"/>
                        <div className="di-video-wrapper"></div>
                    </div>
                    <div className="di-question-title-wrapper">
                        <div className="donot-show-again" onClick={() => setDontshow(!dontshow)}>
                            <input type="checkbox" checked={dontshow} onChange={handleCheckboxChange}/> Don't show again
                        </div>
                        <a href='#' aria-label="Skip button" className="skip-button" onClick={endedAction}>Skip</a>
                        <div className="di-question-title-content di-box-style">
                            {/* <div className="di-play-prgress">
                                <div style={{transform: 'scaleX(' + progress + ')'}}/>
                            </div> */}
                            {!playing &&
                                <div className="di-play-btn di-play-btn-exam" onClick={handlePlay}>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/big-play-white.png`}
                                        srcSet={`${process.env.PUBLIC_URL}/assets/images/big-play-white@3x.png 3x, ${process.env.PUBLIC_URL}/assets/images/big-play-white@2x.png 2x, ${process.env.PUBLIC_URL}/assets/images/big-play-white.png 1x`}
                                        tabIndex={0} alt="Play button" id="img-play-btn"
                                    />
                                    {/* <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/big-pause-white.png`}
                                        srcSet={`${process.env.PUBLIC_URL}/assets/images/big-pause-white@3x.png 3x, ${process.env.PUBLIC_URL}/assets/images/big-pause-white@2x.png 2x, ${process.env.PUBLIC_URL}/assets/images/big-pause-white.png 1x`}
                                        tabIndex={0} alt="Pause button"
                                        id="img-pause-btn"/> */}
                                </div>
                            }
                            <div className="di-video-small-block-wrapper">
                                <div className="di-video-small-block-gradient"/>
                                <div className="di-video-small-block-container" id='explainer-video-wrapper'>
                                    <video ref={explainerVideo}
                                           src={introUrl}
                                           webkit-playsinline="true"
                                           playsInline={true}
                                           muted={muted}
                                           onLoadedMetadata={handleLoadedMetadata}
                                           onEnded={onEndVideo}
                                        //    poster={explainerImg}
                                    />
                                </div>
                                {playing === true && <VideoControls
                                    currentVideoTime={currentVideoTime}
                                    duration={duration}
                                    videoEl={explainerVideo}
                                    muted={muted}
                                    setMuted={setMuted}
                                    playing={playing}
                                    playVideo={playVideo}
                                    showControls={true}

                                />}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
